import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import HRCampusSelector from "../../components/HRCampusSelector";

function currentSchoolYear() {
  const d = new Date();
  const y = d.getMonth() >= 5 ? d.getFullYear() : d.getFullYear() - 1; // start around June
  return `${y}-${y + 1}`;
}

export default function BooksLayout() {
  const [campus, setCampus] = React.useState(() => {
    try { return localStorage.getItem("books_last_campus") || "bulacan"; } catch { return "bulacan"; }
  });
  const [schoolYear, setSchoolYear] = React.useState(() => {
    try { return localStorage.getItem("books_last_sy") || currentSchoolYear(); } catch { return currentSchoolYear(); }
  });
  React.useEffect(() => { try { localStorage.setItem("books_last_campus", campus); } catch (e) { void 0; } }, [campus]);
  React.useEffect(() => { try { localStorage.setItem("books_last_sy", schoolYear); } catch (e) { void 0; } }, [schoolYear]);
  const years = React.useMemo(() => {
    const now = new Date().getFullYear();
    const arr = Array.from({ length: 6 }).map((_, i) => {
      const y = now - 3 + i;
      return `${y}-${y + 1}`;
    }).reverse();
    return ["all", ...arr];
  }, []);
  return (
    <div className="container-fluid px-0">
      <div className="px-4 py-3">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2 className="mb-0">Books (Consignment) — {schoolYear}</h2>
        <div className="d-flex align-items-center gap-2">
          <HRCampusSelector selectedCampus={campus} onChange={setCampus} />
          <select className="form-select" value={schoolYear} onChange={e => setSchoolYear(e.target.value)}>
            {years.map(y => <option key={y} value={y}>{y === "all" ? "All Years" : y}</option>)}
          </select>
        </div>
      </div>
      <ul className="nav nav-tabs mb-3">
        <li className="nav-item"><NavLink className="nav-link" to="/books/inventory">Inventory</NavLink></li>
        <li className="nav-item"><NavLink className="nav-link" to="/books/bundles">Bundles</NavLink></li>
        <li className="nav-item"><NavLink className="nav-link" to="/books/sales">Sales</NavLink></li>
        <li className="nav-item"><NavLink className="nav-link" to="/books/deliveries">Deliveries</NavLink></li>
        <li className="nav-item"><NavLink className="nav-link" to="/books/reports">Reports</NavLink></li>
      </ul>
      <Outlet context={{ campus, schoolYear, setCampus, setSchoolYear, years }} />
      </div>
    </div>
  );
}
